<template>
	<div class="q-cts">
		<div class="q-text">
			<vue-typer text="寝具の中が暑くて目が覚めたり、汗をたくさんかいたりしている" initial-action="typing" :repeat="0" :pre-type-delay="500" :type-delay="70" @completed="onComplete"/>
		</div>
		<transition name="slide-fade">
			<div class="btn-area" v-if="btnFlg">
				<button @click="next(12)" class="btnYes"><img src="@/assets/img/question/btn_yes.png"></button>
				<button @click="next(13)" class="btnNo"><img src="@/assets/img/question/btn_no.png"></button>
			</div>
		</transition>
	</div>
</template>
<script>
import {VueTyper} from 'vue-typer'

export default {
	name: 'QuestionCts09',
	components: {
		VueTyper
	},
	data() {
		return {
			btnFlg: false
		}
	},
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>

